import React, { useEffect, useState } from "react";

const Threshold = () => {
  const [show, setShow] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    try {
      if (!sessionStorage.getItem("tkac_threshold_seen")) {
        setShow(true);
      }
    } catch (_) {
      // sessionStorage unavailable (e.g. private mode) — show the threshold anyway
      setShow(true);
    }
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  const cross = () => {
    setLeaving(true);
    try {
      sessionStorage.setItem("tkac_threshold_seen", "1");
    } catch (_) {
      // sessionStorage unavailable — non-fatal, the threshold will simply reappear next visit
    }
    setTimeout(() => setShow(false), 900);
  };

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[80] bg-background-ivory flex flex-col items-center justify-center text-center px-margin-mobile transition-opacity duration-[900ms] ${
        leaving ? "opacity-0" : "opacity-100"
      }`}
      data-testid="threshold"
    >
      <div
        className={`transition-all duration-1000 ${
          leaving ? "scale-105 opacity-0" : "scale-100 opacity-100"
        }`}
      >
        <div className="mb-10 animate-fade-in flex flex-col items-center">
          <img
            src="/logo-ivory.png"
            alt="The Kitchen Art Co."
            className="h-28 md:h-32 w-auto mx-auto"
            data-testid="threshold-crest"
          />
        </div>
        <p className="font-inter text-eyebrow uppercase tracking-[0.36em] text-brand-secondary mb-6">
          Since 1997
        </p>
        <h1 className="font-cormorant text-[31px] md:text-[64px] leading-[1.05] text-brand-ink mb-6">
          One House. Many Stories.
        </h1>
        <p className="font-inter text-eyebrow uppercase tracking-[0.3em] text-brand-secondary mb-12">
          Creating Experiences Beyond Catering
        </p>
        <button
          onClick={cross}
          className="inline-flex items-center gap-3 border border-brand-gold px-8 py-4 text-brand-ink hover:bg-brand-ink hover:text-ink-on-dark hover:border-brand-ink transition-all duration-500"
          data-testid="threshold-enter"
        >
          <span className="font-inter text-label-sm uppercase tracking-widest">
            Cross the Threshold
          </span>
        </button>
        <p className="font-inter text-[9px] tracking-[0.3em] uppercase text-brand-secondary mt-14">
          Since 1997 &nbsp;·&nbsp; Pan India &amp; Abroad &nbsp;·&nbsp; Crafted by Masters &nbsp;·&nbsp; Trusted by Generations
        </p>
      </div>
    </div>
  );
};

export default Threshold;
